import { generateCancelRequestToken } from "./HttpRequest"

const AbortStackRequestService = {
  stackRequest: [],

  newRequest(request, requestParams = []) {
    const {token, cancel} = generateCancelRequestToken()
    request(token, ...requestParams)
    this.stackRequest.push({ cancel, token })
    this.persistLastRequest()
  },

  persistLastRequest() {
    const lastRequestIndex = this.stackRequest.length - 1
    this.stackRequest.forEach((x, i) => lastRequestIndex !== i && x && x.cancel())
    this.stackRequest = this.stackRequest.filter((_x, i) => lastRequestIndex === i)
  },
  
  cancelAllStackedRequests() {
    this.stackRequest.forEach(x => x && x.cancel())
  }
}

export default AbortStackRequestService



// WEBPACK FOOTER //
// ./src/services/AbortStackRequestService.js